export class TableOptionsModel {
    public page!: number;
    public itemsPerPage!: number;
    public itemsLength!: number;
}